/* eslint-disable */
import prodotti from "@/services/prodottiService.js";
import configurazioni from "@/services/configurazioniService.js";
import movimenti from "@/services/movimentiService.js";
import fidelity from "@/services/fidelityService.js";
import scontrini from "@/services/scontriniService.js";
import clienti from "@/services/clientiService.js";
import appuntamenti from "@/services/appuntamentiService.js";
import etichette from "@/services/etichetteService.js";
import magazzino from "@/services/magazzinoService.js";
import stampante from "@/services/stampanteService.js";
import tabelle from "@/services/tabelleService.js";
import documenti from "@/services/documentiService.js";
import licenze from "@/services/licenzeService.js";
import reporting from "@/services/reportingService.js";

export const insomnia = {
  data() {
    return {
      status: [],
    };
  },
  methods: {
    async cicleSyncProcess(multiplo) {
      try {
        await prodotti.cicleSync(multiplo);
        await configurazioni.cicleSync(multiplo);
        await movimenti.cicleSync(multiplo);
        await magazzino.cicleSync(multiplo);
        await fidelity.cicleSync(multiplo);
        await scontrini.cicleSync(multiplo);
        await clienti.cicleSync(multiplo);
        await appuntamenti.cicleSync(multiplo);
        await tabelle.cicleSync(multiplo);
        await documenti.cicleSync(multiplo);
        await reporting.cicleSync(multiplo);
      } catch (error) {
        console.log("errore cicleSyncProcess", error);
      }
    },
    async getProcessStatus(payload) {
      // const status = []
      if (this.status.length > 0) {
        console.log("stato in cache");
        return this.status;
      }
      try {
        this.status.push(await prodotti.getRunMode());
        const statusConfigurazioni = await configurazioni.getRunMode();
        const baseDb = statusConfigurazioni.baseDb;
        this.status.push(statusConfigurazioni);
        this.status.push(await movimenti.getRunMode());
        this.status.push(await fidelity.getRunMode());
        this.status.push(await scontrini.getRunMode());
        this.status.push(await clienti.getRunMode());
        this.status.push(await appuntamenti.getRunMode());
        this.status.push(await etichette.getRunMode());
        this.status.push(await magazzino.getRunMode());
        const statusStampante = await stampante.getRunMode();
        statusStampante.payload = payload;
        this.status.push(statusStampante);
        this.status.push(await tabelle.getRunMode());
        this.status.push(await documenti.getRunMode());
        this.status.push(await reporting.getRunMode());
        const statusDisplay = this.getStatusDisplay();
        this.status.push(statusDisplay);
        await licenze.sendModuleInfo(baseDb, this.status);
      } catch (error) {
        console.log("errore getProcessStatus", error);
      }
      console.log("nuovo stato");
      const status = this.status;
      this.status = [];
      return status;
    },
    async debugMode() {
      try {
        return await configurazioni.getRunMode();
      } catch (error) {
        console.log("errore debugMode", error);
        return {};
      }
    },
    getStatusDisplay() {
      /* eslint-disable */
      return {
        baseDb: "",
        tipo: "client",
        data: new Date(),
        modulo: "DISPLAY",
        debugMode: false,
        onlyRemote: false,
        locale: "--no DB--",
        remote: "--no DB--",
        version: configurazioni.getDisplayVersion(),
        health: true, // Verificare come calcolare
      };
    },
  },
};
